/**
 * @desc 导出锁定单据列表
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(
  params: API.stock.stockOrder.exportListStockOrderDetail.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/stock/order/detail/export/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
